/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StatisticType {
    COMPANY_STATISTIC = 'CompanyStatistic',
    SOFTWARE_STATISTIC = 'SoftwareStatistic',
    SUB_ACCOUNT_STATISTIC = 'SubAccountStatistic',
}
